import size from 'lodash/size'

import logger from '~/lib/logger'

const TEST_VAL = '_____test-value______'

export class StorageFallback {
    constructor() {
        this.mem = {}
    }

    setItem(key, value) {
        this.mem[key] = String(value)
    }

    getItem(key) {
        return this.mem[key]
    }

    removeItem(key) {
        const val = this.mem[key]

        delete this.mem[key]
        return val
    }

    clear() {
        this.mem = {}
    }

    get length() {
        return size(this.mem)
    }
}

/**
 * @deprecated - we don't need any polyfills for browser storages
 * instead follow this guide src/lib/services/WebStorage
 */
export default class LocalStorageWrapper {
    constructor(storageType = 'localStorage') {
        try {
            this.storage =
                typeof window !== 'undefined' &&
                typeof window[storageType] !== 'undefined'
                    ? /* istanbul ignore next */
                      window[storageType]
                    : new StorageFallback()

            this.storage.setItem(TEST_VAL, TEST_VAL)
            this.storage.removeItem(TEST_VAL)
        } catch (error) {
            logger.warn(
                `${storageType} failed, falling back to in memory storage`,
            )
            this.storage = new StorageFallback()
        }
    }

    setItem(key, value) {
        try {
            this.storage.setItem(key, value)
        } catch (error) {
            logger.warn('Storage.setItem failed, clearning and setting again')
            this.storage.clear()
            this.storage.setItem(key, value)
        }
    }

    getItem(key) {
        return this.storage.getItem(key)
    }

    removeItem(key) {
        return this.storage.removeItem(key)
    }

    clear() {
        this.storage.clear()
    }

    get length() {
        return this.storage.length
    }
}
